import { useEffect, useState } from 'react'
import { useSearchParams, useParams } from 'react-router-dom'
import { sendCredential } from './core/_request'
import { CredentialDto } from '../../auth'
import { showError } from '../../../../_metronic/helpers'

export const CertificadoPage = () => {
  const { token } = useParams()
  const [params] = useSearchParams()
  const code = params.get('code')

  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')

  useEffect(() => {
    const sendCrendenciais = async () => {
      try {
        if (!token || !code) {
          setStatus('error')
          setLoading(false)
          return
        }

        const data: CredentialDto = { token, credential: code }
        await sendCredential(data)

        setStatus('success')
        setLoading(false)
      } catch (error) {
        showError(error)
        setStatus('error')
        setLoading(false)
      }
    }

    sendCrendenciais()
  }, [token, code])

  return (
    <div className='text-center'>
      {loading && (
        <>
          <div className='spinner-border text-primary my-5' />
          <h3>Autorizando certificado...</h3>
          <p>Por favor aguarde, isso pode levar alguns segundos.</p>
        </>
      )}

      {!loading && status === 'success' && (
        <>
          <h2 style={{ color: 'green' }}>✔ Certificado autorizado!</h2>
          <p className='mt-3'>Você já pode voltar para o computador.</p>
        </>
      )}

      {!loading && status === 'error' && (
        <>
          <h2 style={{ color: 'red' }}>Erro ao autorizar</h2>
          <p className='mt-3'>Feche a página e tente novamente.</p>
        </>
      )}
    </div>
  )
}
